/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

class DisplayCommand extends Component {
    render() {
        let {command} = this.props
        return (
            <div
                className={"overflow-auto whitespace-nowrap bg-black text-white font-mono p-2 rounded customScrollbarSmall"}>
                <span className={"select-none"}>$</span> {command}
            </div>
        );
    }
}

DisplayCommand.propTypes = {
    command: PropTypes.any
};

DisplayCommand.defaultProps = {};


export default DisplayCommand;